import o from "./locale.js";
var r, t, f;
e({
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});
function e(a) {
  return r = o(a), t = r.format, f = r.formatPrefix, r;
}
export {
  e as default,
  t as format,
  f as formatPrefix
};
